export class Draft {
    properties: DraftProperties = new DraftProperties()
    setting: DraftComponents = new DraftComponents()
    story: DraftStory = new DraftStory()

}

export class DraftProperties {
    genre: string[] = []
    linear: boolean = true
    lines: number = 1
    person: number = 1
    synopsis: string = ``
}

export class DraftLine {
    id: number = 0
    title?: string
    description?: string
    summary?: string
}

export class DraftComponentCategory  {
    id: number = 0
    category: string = ''
    title?: string
    description?: string
    components: DraftComponent[] = []
}

export class DraftComponents {
    title?: string
    description?: string
    categories: DraftComponentCategory[] = []
}

export class DraftElement {
    embedded?: boolean
    id: number = 0
    title?: string
    description?: string
    items: DraftElementItem[] = []
}

export class DraftElementItem {
    id: number = 0
    title?: string
    description?: string
    embedded?: boolean
}

export class DraftComponent {
    id: number = 0
    title?: string
    description?: string
    elements: DraftElement[] = []
}

export class DraftStory {
    title: string = "Untitled"
    lines: DraftLine[] = []
    acts: DraftAct[] = [{id: 1, title: "Завязка", chapters: []}, {id: 2, title: "Кульминация", chapters: []}, {
        id: 3,
        title: "Развязка",
        chapters: []
    }]
}

export class DraftAct {
    id: number = 0
    title?: string
    description?: string
    chapters: DraftChapter[] = []
}

export class DraftChapter {
    id: number = 0
    title?: string
    description?: string
    sections: DraftSection[] = []
}

export class DraftSection {
    id: number = 0
    title?: string
    description?: string
    scenes: DraftScene[] = []
}

export class DraftScene {
    id: number = 0
    title?: string
    description?: string
    shots: DraftShot[] = []
}

export class DraftShot {
    id: number = 0
    description?: string
    environment?: string
    place?: string
    time?: string
    narration: DraftNarration = new DraftNarration()
    line: number = 1
    choice?: DraftChoice[]
}

export class DraftChoice {
    line: number = 1
    title?: string
}

export class DraftNarration {
    text?: string
    character?: string
    expression?: string
}

export const genres = [
    {"russian": "Роман", "english": "Novel"},
    {"russian": "Рассказ", "english": "Short Story"},
    {"russian": "Поэзия", "english": "Poetry"},
    {"russian": "Драма", "english": "Drama"},
    {"russian": "Фантастика", "english": "Science Fiction"},
    {"russian": "Фэнтези", "english": "Fantasy"},
    {"russian": "Детектив", "english": "Detective"},
    {"russian": "Триллер", "english": "Thriller"},
    {"russian": "Мистика", "english": "Mystery"},
    {"russian": "Биография", "english": "Biography"},
    {"russian": "Автобиография", "english": "Autobiography"},
    {"russian": "Исторический", "english": "Historical"},
    {"russian": "Приключения", "english": "Adventure"},
    {"russian": "Ужасы", "english": "Horror"},
    {"russian": "Романтика", "english": "Romance"},
    {"russian": "Сатира", "english": "Satire"},
    {"russian": "Комедия", "english": "Comedy"},
    {"russian": "Детский", "english": "Children"},
    {"russian": "Мемуары", "english": "Memoir"},
    {"russian": "Документальный", "english": "Non-fiction"},
    {"russian": "Эпопея", "english": "Epic"},
    {"russian": "Легенда", "english": "Legend"},
    {"russian": "Мифология", "english": "Mythology"},
    {"russian": "Новелла", "english": "Novella"},
    {"russian": "Антиутопия", "english": "Dystopian"},
    {"russian": "Утопия", "english": "Utopian"},
    {"russian": "Постапокалипсис", "english": "Post-apocalyptic"},
    {"russian": "Киберпанк", "english": "Cyberpunk"},
]

export const embeddedElements = (elements: DraftElement[]): boolean | undefined => {
    const embedded = elements?.filter(e => e.embedded == true)?.length
    return !elements || elements?.length == 0 || embedded == 0 ? false : embedded == elements?.length ? true : undefined
}

export const embeddedItems = (items: DraftElementItem[]): boolean | undefined => {
    const embedded = items?.filter(e => e.embedded == true)?.length
    return !items || items?.length == 0 || embedded == 0 ? false : embedded == items?.length ? true : undefined
}

export const embeddedComponents = (components: DraftComponentCategory | DraftComponent[]): boolean | undefined => {
    const comps = Array.isArray(components) ? components : components.components
    const embedded = comps?.filter(e => embeddedElements(e.elements) == true)?.length
    const halfEmbedded = comps?.filter(e => embeddedElements(e.elements) == undefined)?.length
    return comps?.length == 0 || (embedded == 0 && halfEmbedded == 0) ? false : embedded == comps?.length ? true : undefined
}

export const embeddedCategories = (components: DraftComponents | DraftComponentCategory[]): boolean | undefined => {
    const cats = Array.isArray(components) ? components : components.categories
    const embedded = cats?.filter(e => embeddedComponents(e.components) == true)?.length
    const halfEmbedded = cats?.filter(e => embeddedComponents(e.components) == undefined)?.length
    return cats?.length == 0 || (embedded == 0 && halfEmbedded == 0) ? false : embedded == cats?.length ? true : undefined
}

export const fullfilledElements = (elements: DraftElement[]): boolean | undefined => {
    return !elements || elements?.length == 0 ? false : elements?.filter(e => e.title && e.description && e.title.trim().length > 0 && e.description.trim().length > 0)?.length == elements?.length ? true : undefined
}

export const fullfilledComponents = (components: DraftComponentCategory | DraftComponent[]): boolean | undefined => {
    const comps = Array.isArray(components) ? components : components.components
    return comps?.length == 0 ? false : comps?.filter(e => fullfilledElements(e.elements) == true)?.length == comps?.length ? true : undefined
}

export const fullfilledCategories = (components: DraftComponents | DraftComponentCategory[]): boolean | undefined => {
    const cats = Array.isArray(components) ? components : components.categories
    return cats?.length == 0 ? false : cats?.filter(e => fullfilledComponents(e.components) == true)?.length == cats?.length ? true : undefined
}